/** Shared quotations list page size (POS `start`/`size` → BOP). Keep free of store imports. */
export const QUOTATIONS_PAGE_SIZE = 200;
